export const generateRandomKey = () => {
    const randomValues = new Uint32Array(2);
    return `${(Math.floor(crypto.getRandomValues(randomValues).at(0)))}-${(Math.floor(crypto.getRandomValues(randomValues).at(1)))}`
}
